
export const ReporteLang = {
  cotizacion: {
    es: "Cotización",
    en: "Quotation",
  },
  Origin: {
    es: "Origen",
    en: "Origin",
  },
  fecha: {
    es: "Fecha: ",
    en: "Date: ",
  },
  cliente: {
    es: "Cliente: ",
    en: "Customer: ",
  },
  Buyer: {
    es: "Buyer: ",
    en: "Buyer: ",
  },
  agente: {
    es: "Agente de Ventas: ",
    en: "Sales Agent: ",
  },
  terminoC: {
    es: "Término de Compra: ",
    en: "Purchase Term: ",
  },
  terminoE: {
    es: "Término de Envío: ",
    en: "Shipment Term: ",
  },
  styleC: {
    es: "CATEGORIA",
    en: "CATEGORY",
  },
  hilo: {
    es: "HILO",
    en: "YARN",
  },
  styleT: {
    es: "TEJIDO",
    en: "FABRIC",
  },
  dyeType: {
    es: "TEÑIDO",
    en: "DYE",
  },
  densidad: {
    es: "DENSIDAD",
    en: "DENSITY",
  },
  unidad: {
    es: "UNIDAD",
    en: "UNIT",
  },
  cantidad: {
    es: "CANTIDAD",
    en: "QUANTITY",
  },
  UnitCost: {
    es: "PRECIO",
    en: "PRICE",
  },
  PROCESS: {
    es: "PROCESO",
    en: "PROCESS",
  },
  comentario: {
    es: "Comentario",
    en: "Comment",
  },
  adicionales: {
    en: "Additional Cost: ",
    es: "Costos Adicionales: ",
  },
  Pagina: {
    es: "Página",
    en: "Page",
  },  
  firma: {
    es: "FIRMA AUTORIZADA",
    en: "AUTHORIZED SIGNATURE",
  },
  costo: {
    es: "Procesos Especiales",
    en: "Special Process",
  },  
  datePrint: {
    en: "Print Date",
    es: "Fecha de Impresión",
  },  

  //CONTENIDO
  title: {
    es: "Términos y condiciones de confirmación de pedido",
    en: "Terms and Conditions of Order confirmation",
  },
  text1: {
    es: "Es un placer confirmar la recepción de su orden de compra del tejido solicitado. A continuación se detallan los términos y condiciones de la compra:",
    en: "It is a pleasure to confirm the receipt of your purchase order for the requested fabric. Below are the terms and conditions of the purchase:",
  },
  text2: {
    es: "En Pride Performance Fabrics (PPF), estamos comprometidos a ofrecer productos de alta calidad, inspeccionados según las normas ASTM D5430 y evaluados en laboratorios acreditados. Las siguientes son pautas importantes:",
    en: "At Pride Performance Fabrics (PPF), we are committed to offering high-quality products, inspected ac-cording to ASTM D5430 standards and evaluated in accredited laboratories. The following are important guidelines:",
  },
  payment: {
    es: "1. Términos de pago",
    en: "1. Payment Terms",
  },
  text3: {
    es: "1. Los plazos de pago son",
    en: "1. Payment terms are",
  },
  text3_1: {
    es: " [Según cada cliente]",
    en: " [According to each client]",
  },
  text3_2: {
    es: " después de la fecha de la factura, no debiendo excederse este plazo.",
    en: " days after the invoice date, and this deadline should not be exceeded.",
  },
  text4: {
    es: "2. En caso de excederse la fecha de pago, PPF se reserva el derecho de aplicar una penalización del ",
    en: "2. Should the payment date be exceeded, PPF reserves the right to apply a penalty fee of  ",
  },
  text4_1: {
    es: "%",
    en: "%",
  },
  text4_2: {
    es: ". En caso de pagos atrasados ​​recurrentes, la cuenta se suspenderá y no se liberarán más envíos hasta que la cuenta esté completamente liquidada.",
    en: ". In the event of recurring missed payments, the account will be placed on hold, and no further shipments will be released until the account is fully settled.",
  },

  bank: {
    es: "2. Cuenta bancaria",
    en: "2. Bank account",
  },
  text5: {
    es: "1. El cliente deberá utilizar la información de nuestra cuenta bancaria:",
    en: "1. The client must use our Bank account information: ",
  },
  text6: {
    es: "Banco Ficohsa, (Swift: FCOHHNTE) Col. Las Colinas, Blvd Francia, Edif Plaza Victoria,Tegucigalpa, Honduras, CA, Tel: pbx. 504-2239-6410.",
    en: "Banco Ficohsa, (Swift: FCOHHNTE) Col. Las Colinas, Blvd Francia, Edif Plaza Victo-ria,Tegucigalpa, Honduras, CA, Tel: pbx. 504-2239-6410.",
  },
  shipping: {
    es: "3. Tolerancia de envío:",
    en: "3. Shipping tolerance:",
  },
  text7: {
    es: "% la asignación en cantidad y monto es aceptable",
    en: "% allowance in quantity and amount are acceptable",
  },
  yarn: {
    es: "4. PO de hilo y PO de mercancías Greige",
    en: "4. Yarn PO and Greige Goods PO",
  },
  text8: {
    es: "1. En el caso de que se requieran hilados o mercancías crudas por adelantado en relación con la Orden de Compra, el cliente será financieramente responsable de cualquier volumen de tela cruda sobrante.",
    en: "1. In the event that yarn or greige goods are required in advance related to the Purchase Order, the client shall be financially responsible for any volume of greige fabric left-over. ",
  },
  Non: {
    es: "5. Notificación de producto no conforme",
    en: "5. Non-Conforming Product Notification",
  },
  text9: {
    es: "1. Si el producto recibido no cumple con los requisitos solicitados, el cliente tiene un máximo ",
    en: "1. If the product received does not meet the requested requirements, customers have a maximum ",
  },
  text9_1: {
    es: " treinta (30) días  ",
    en: " thirty (30) days  ",
  },
  text9_2: {
    es: " para notificárnoslo mediante el formulario de ",
    en: " to notify us using ",
  },
  text9_3: {
    es: " Solicitud de devolución o reemplazo de producto no conforme (FR-QC-030), .",
    en: " Non-Conforming Product Return or Replacement Request form (FR-QC-030), ",
  },
  text9_4: {
    es: "enviándolo vía correo electrónico a nuestro equipo de calidad.",
    en: "sending it via email to our quality team.",
  },

  text10: {
    es: "2. En caso de un formulario de ",
    en: "2. In the event of a ",
  },
  text10_1: {
    es: " Solicitud de devolución o reemplazo de producto no conforme (FR-QC-030), ",
    en: " Non-Conforming Product Return or Replacement Request form (FR-QC-030), ",
  },
  text10_2: {
    es: "el producto original debe devolverse a las instalaciones de PPF.",
    en: "the original product must be returned to the PPF facilities. ",
  },
  validation: {
    es: "6. Proceso de inspección de calidad de validación",
    en: "6. Validation Quality Inspection Process",
  },
  text11: {
    es: "1. Unauditor externo del PPF verificará los problemas reportados en un plazo no mayor a",
    en: "1. A PPF external auditor will verify the reported issues within no more than",
  },
  text11_1: {
    es: " tres (3) días ",
    en: " three (3) days ",
  },
  text11_2: {
    es: "posteriores a la notificación. Se debe designar un representante para presentar los problemas al auditor y proporcionar el espacio adecuado para la inspección.",
    en: "after the notification. A representative should be designated to present the issues to the auditor and provide adequate space for the inspection.",
  },
  text12: {
    es: "2. Organización de pruebas de telas: Pride Performance Fabrics S.A de C.V.  Prueba interna.",
    en: "2. Fabric testing organization: Pride Performance Fabrics S.A de C.V.  In House Test.",
  },
  text13: {
    es: "3. En caso de que se requiera alguna prueba de terceros después de la validación de calidad; ",
    en: "3. In the event that any third-party testing is required after validation quality; ",
  },
  text13_1: {
    es: " y PPF deben acordar quién será responsable del pago; si el ",
    en: " and PPF must agree who will be responsible for payment, if ",
  },
  text13_2: {
    es: "envió la tela o prenda para cualquier prueba de terceros a un laboratorio de terceros sin confirmación o validación con PPF, entonces no tomaremos ninguna responsabilidad por cualquier costo, y todos los costos asociados deben ser cargados al",
    en: "submitted fab-ric or garment for any third-party testing is required to third party lab without confirmation or validation with PPF then we will not take any responsibility for any cost, and all associ-ated costs must charge to",
  },
  text13_3: {
    es: ". Estos cargos se reflejarán en la factura posterior o se emitirán mediante nota de débito.",
    en: ". These charges will be reflected in the subse-quent invoice or issued through a debit note.",
  },
  text14: {
    es: "4. La reclamación se resolverá con prontitud, con respeto mutuo y cooperación hasta llegar a un acuerdo. Este proceso no debe exceder los ",
    en: "4. The claim shall be resolved promptly, with mutual respect and cooperation until an agreement is reached. This process should not exceed ",
  },
  text14_1: {
    es: "sesenta (60) días, ",
    en: "sixty (60) days, ",
  },
  text14_2: {
    es: " más allá de los cuales PPF ya no considerará válido el reclamo.",
    en: " beyond which PPF will no longer consider the claim valid.",
  },
  text15: {
    es: "5. Al llegar a un acuerdo, cualquier pago pendiente se liquidará mediante factura o nota de débito posterior, a pagar o aplicar dentro de los ",
    en: "5. Upon reaching an agreement, any outstanding payment will be settled through a subse-quent invoice or debit note, to be paid or applied within ",
  },
  text15_1: {
    es: "siete (7) días.",
    en: "seven (7) days.",
  },
  return: {
    es: "7. Condiciones de devolución",
    en: "7. Return Conditions",
  },
  text16: {
    es: "1. El producto debe estar en su estado original de envío sin modificaciones. PPF no será responsable de ningún tejido o prenda cortada. Si la tela se corta antes de la notificación, el cliente asume toda la responsabilidad. No se aceptarán reclamaciones por cortes de tela, prendas o daños ocurridos durante el almacenamiento después de la entrega.",
    en: "1. The product must be in its original shipped condition with no alterations. PPF will note lia-ble for any cut fabric or garments. If the fabric is cut before notification, the client as-sumes full responsibility. Claims for cut fabric, garments, or damage occurring during storage after delivery will not be accepted.",
  },
  types: {
    es: "8. Tipos de Devolución y Reemplazo",
    en: "8. Types of Return and Replacement",
  },
  text17: {
    es: "1. Una vez verificado el reclamo, se procederá oportunamente a la sustitución o devolución con base en las conclusiones del auditor y/o mutuo acuerdo.",
    en: "1. Once the claim is verified, replacement or return will proceed in a timely manner based on the auditor's findings and/or mutual agreement.",
  },
  cargos: {
    es: "9. Cargos de terceros",
    en: "9. Third-Party Charges",
  },
  text18: {
    es: "1. PPF no será responsable de reembolsar al cliente los costos, gastos o pagos realizados a terceros en relación con la ejecución de esta orden. Esto incluye: honorarios por servicios de terceros, subcontratistas, proveedores, consultores o cualquier entidad externa contratada por el cliente o en su nombre.",
    en: "1. PPF shall not be responsible for reimbursing the client for any costs, expenses, or pay-ments made to third parties in connection with the execution of this order. This includes to: fees for third-party services, subcontractors, suppliers, consultants, or any external entities engaged by the client or on their behalf.",
  },
  text19: {
    es: "2. Esto solo puede ocurrir si el control de calidad acepta el nuevo proceso para resolver cualquier problema de control de calidad que pueda ser menor que el costo del flete.",
    en: "2. This can only occurs if QC accepts the new process to solve any QC issues that may be less than the freight charge cost. ",
  },
  text20: {
    es: "3. El cliente reconoce que cualquier acuerdo, transacción u obligación que involucre a terceros es independiente de las responsabilidades de PPF y no forma parte de este contrato.",
    en: "3. The client acknowledges that any agreements, transactions, or obligations involving third parties are independent of PPF's responsibilities and do not form part of this contract.",
  },
  text21: {
    es: "4. La responsabilidad de PPF se limita estrictamente a los servicios y entregables descritos en este acuerdo y no se extiende a los cargos auxiliares o externos incurridos durante el proceso.",
    en: "4. PPF's liability is limited strictly to the services and deliverables outlined in this agreement and does not extend to ancillary or external charges incurred during the process.",
  },
  fuerza: {
    es: "10. Fuerza mayor o caso fortuito",
    en: "10. Force Majeure or Act of God",
  },
  text22: {
    es: "1. Si cualquiera de las partes cree que ha ocurrido o puede ocurrir un evento de Fuerza Mayor o Caso Fortuito, que afecta su capacidad para cumplir con las obligaciones bajo este acuerdo, deberá notificarlo inmediatamente a la otra parte por escrito. Esta notificación deberá realizarse en un plazo máximo de ",
    en: "1. If either party believes that a Force Majeure or Act of God event has occurred or may occur, which affects their ability to fulfill the obligations under this agreement, they must immediately notify the other party in writing. This notification must be made within a max-imum of ",
  },
  text22_1: {
    es: "cinco (5) días ",
    en: "five (5) ",
  },
  text22_2: {
    es: "días hábiles posteriores al evento. La falta de notificación en este plazo supondrá que el afectado pierda el derecho a presentar reclamación.",
    en: "business days after the event. Failure to notify within this timeframe will result in the affected party losing the right to make a claim.",
  },
  text23: {
    es: "Al firmar a continuación, acepta los términos y condiciones establecidos en esta confirmación de orden de compra. Se requiere su consentimiento y aprobación para proceder con la liberación del pedido.",
    en: "By signing below, you agree to the terms and conditions set forth in this purchase order confirmation. Your consent and approval are required to proceed with the release of the order.",
  },
  firmaContenido: {
    es: "Firma Autorizada",
    en: "Authorized Signature",
  },
  firmaContenido1: {
    es: "Pride Performance Fabrics S.A de C.V",
    en: "Pride Performance Fabrics S.A de C.V",
  },
  firmaContenido2: {
    es: "Cliente (x)",
    en: "Customer (x)",
  },

  textFinal: {
    es:'Durante la fase de desarrollo de color, las muestras no excederán de 5 yardas. Si se requieren cantidades mayores, serán a cargo y costo del cliente. Las muestras para aprobación de color y orden no excederán de 10 yardas; cantidades superiores se cargarán a la cuenta del cliente.',
    en:'During the color development phase, samples will not exceed 5 yards. If larger quantities are required, the cost will be borne by the client. Color approval samples and order samples will not exceed 10 yards; any quantities beyond this will be charged to the client`s account.',
  },
  noHayDatos:{
    es: 'No hay datos para mostrar',
    en: 'No data to show'
  },
  tokenNoValido: {
    es: 'Token no válido',
    en: 'Invalid token'
  },
  muestras: {
    es:'Muestras para desarrollo y aprobación: ',
    en:'Samples for Development and Approval: ',
  },
  Titulo: {
    es: 'Confirmación de Orden de Compra',
    en: 'Purchase Order Confirmation',
  },

  CONTENT: {
    en: "CONTENT",
    es: "CONTENIDO",
  },  
  TYPE: {
    en: "TYPE",
    es: "TIPO",
  },
  YARN: {
    en: "YARN",
    es: "HILO",
  },
  "WEIGHT GSM": {
    en: "WEIGHT GSM",
    es: "PESO GSM",
  },
  "CUTTABLE GSM": {
    en: "CUTTABLE GSM",
    es: "CORTABLE GSM",
  },
  "FULL WIDTH": {
    en: "FULL WIDTH",
    es: "ANCHO COMPLETO",
  },
  KG: {
    en: "KG",
    es: "KG",
  },
  LB: {
    en: "LB",
    es: "LIBRAS",
  },
  YD: {
    en: "YD",
    es: "YARDAS",
  },
  CIFPRICES: {
    es: "PRECIOS",
    en: "PRICES",
  },

  Price: {
    es: "Precio",
    en: "Price",
  },

};